import HttpClient from '../httpClient';
import LikeTypesService from './likeTypesService';
import UsersService from './usersService';
import Like from '../models/like';

const LikesService = {

  parseLike: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      createdAt: new Date(response.created_at),
      user: UsersService.parseUser(response._embedded['dm:user:v1']),
      likeType: LikeTypesService.parseLikeType(response._embedded['dm:like_type:v1']),
      _links: response._links,
      _forms: response._forms
    };
  },

  createLike(entry, likeType) {
    const likeParams = { like_type: { id: likeType.id } };
    const createLikeForm = entry.getForm('dm:create_like:v1');

    return HttpClient[createLikeForm.method](createLikeForm.href, { like: likeParams }).then(response => {
      const likeProps = LikesService.parseLike(response);
      return new Like(likeProps);
    });
  },

  destroyLike(like) {
    const url = like.getLink('self').href;
    return HttpClient.destroy(url).then(() => like);
  }

};

export default LikesService;


// WEBPACK FOOTER //
// ./src/api/services/likesService.js